import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollToTop = () => {
  const { pathname, hash, search } = useLocation();

  useEffect(() => {
    // If there's a hash (e.g., #venue), try to scroll to that element
    if (hash) {
      const elementId = hash.replace('#', '');

      // Use a raf to allow the page to render before attempting to scroll
      const scrollToHash = () => {
        const target = document.getElementById(elementId);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return true;
        }
        return false;
      };

      // Attempt immediately, then fallback after next frame if not ready yet
      if (!scrollToHash()) {
        requestAnimationFrame(() => {
          scrollToHash();
        });
      }
      return;
    }

    // Default behavior: scroll to top on route change
    // Use requestAnimationFrame to ensure scroll happens after DOM updates
    // Double RAF ensures it happens after React has rendered the new route
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior });
        // Also scroll the document element as a fallback
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      });
    });
  }, [pathname, hash, search]);

  return null;
};
